module.exports = __webpack_public_path__ + "img/l1.c6baf657.png";